<div class="device-wrapper">

  <!-- Kalan Hak fattiyse -->
  <div *ngIf="deviceCount <= 0" class="limit-box">

    <div class="icon-wrap error">
      <i class="fa fa-exclamation-octagon"></i>
    </div>

    <h2 class="limit-title">Cihaz Tanımlama Hakkınız Doldu</h2>

    <p class="limit-text">
      Bu ay için tanımlama hakkınız tükendi.
      <br />Sorun olduğunu düşünüyorsanız geri faldirim gönderefalirsiniz.
    </p>

    <button class="limit-button" (click)="router.navigate(['/feedback'])">
      <i class="fa fa-chat-dots"></i> Geri faldirim Gönder
    </button>

    <div class="device-info">
      <i class="fa fa-cpu info-icon"></i>
      <div>
        <span class="info-label">Cihaz ID</span>
        <div class="info-value">{{ user?.data?.slice(-1)[0]?.deviceId }}</div>
      </div>
    </div>

  </div>

  <!-- Hak Varsa -->
  <div *ngIf="deviceCount > 0" class="verify-box">

    <div class="header-row">


      <div class="header-text">
        <h2 class="verify-title">Yeni Cihaz Ekle</h2>
        <p class="verify-subtitle">
          <i class="fa fa-shield-check me-1"></i>
          Telefon numarası ile doğrulama yapın.
        </p>
      </div>

      <div class="limit-status">
        <div class="status-icon">
          <i class="fa-solid fa-bolt"></i>
        </div>
        <div class="status-text">
          <span class="top">Kalan Doğrulama Hakkı</span>
          <span class="count">{{ deviceCount }}</span>
        </div>
      </div>
    </div>


    <!-- Cihaz Adı -->
    <div class="form-group">
      <label><i class="fa fa-tag"></i> Cihaz Adı</label>
      <input class="form-input" [(ngModel)]="deviceName" placeholder="Örn: iPhone 13" />
    </div>

    <!-- Telefon -->
    <div class="form-group" *ngIf="!isCodeSent">
      <label><i class="fa fa-telephone"></i> Telefon Numarası</label>
      <input class="form-input" [(ngModel)]="phoneNumber" disabled="true" type="tel" placeholder="05xx xxx xx xx" />
    </div>

    <button class="primary-btn" *ngIf="!isCodeSent" (click)="sendSms()">
      <i class="fa fa-chat-left-text"></i> SMS Gönder
    </button>

    <!-- SMS GELDİKTEN SONRA -->
    <div *ngIf="isCodeSent">
      <div class="form-group mt-3">
        <label><i class="fa fa-shield-lock"></i> SMS Kodu</label>
        <input class="form-input" [(ngModel)]="smsCode" placeholder="6 haneli kod" />
      </div>

      <button class="success-btn mt-2" (click)="verifySmsCode()">
        <i class="fa fa-check-circle"></i> Doğrula
      </button>
    </div>

  </div>

</div>
